import { render, staticRenderFns } from "./detail_page.vue?vue&type=template&id=a9eb27fc&scoped=true"
import script from "./detail_page.vue?vue&type=script&lang=js"
export * from "./detail_page.vue?vue&type=script&lang=js"
import style0 from "./detail_page.vue?vue&type=style&index=0&id=a9eb27fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9eb27fc",
  null
  
)

export default component.exports